import { render, staticRenderFns } from "./ModalFloot.vue?vue&type=template&id=561eb100&"
var script = {}
import style0 from "./ModalFloot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports